import script from "./ButtonGhost.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonGhost.vue?vue&type=script&setup=true&lang=js"

import "./ButtonGhost.vue?vue&type=style&index=0&id=abba51b8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abba51b8"]])

export default __exports__